import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../../lib/routing";

export const multisiteRoutes: Array<RouteObject> = [
  {
    path: "*",
    id: "multisite",
    lazy: async () => convertRouteModule(await import("./index")),
    children: [
      {
        index: true,
        lazy: async () => convertRouteModule(await import("./application")),
      },
    ],
  },
];
